import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiPlusCircle, FiEye } from "react-icons/fi";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { isArray } from "lodash";

import { getAllIncidentHistory } from "app/_services/ehs/ehsIncidentServices";
import {
  contractorDesignationLabel,
  contractorDropdownLabel,
  employeeDesignationLabel,
  employeeDropdownLabel,
  formatDDMMYYYYbyYYYYMMDD,
  fullNameLabel,
} from "app/_helpers/helper";
import {
  incidentStatuses,
  incidentTypes,
  severities,
  getIncidentStatusClass,
  getIncidentSeverityClass,
  incidentFilterFields,
  validateRowFilter,
  CURRENT_SEVERITY,
  staffType,
  checkStatusByFilter,
  INCIDENT_STATUS_VIEW,
  checkLtiWithType,
} from "./CONSTANTS";

import BackBtn from "app/Components/CommanComponents/BackBtn";

import {
  isUserRO,
  isUserMM,
  isUserSO,
  getLoggedInUserId,
  checkStringsAreEqual,
  isUserInvestigator,
} from "../IncidentManagement/Helper";
import IncidentFilters from "./IncidentFilters.component";
import { useForm } from "app/_helpers/hooks";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import { ACTIVE_MODULE } from "app/_constants/constant";
import {
  DDMMYYYYFormat,
  DDMMYYYYHHMMAFormat,
  isBetween,
  YYYYMMDDFormat,
} from "app/_helpers/dateHelper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const { SearchBar } = Search;

function MyApprovalHistory({
  match: {
    params: { siteId },
  },
}) {
  const [tab, setTab] = useState(
    isUserRO() ? 1 : isUserSO() ? 2 : isUserMM() ? 3 : isUserInvestigator() ? 4 : 0
  );
  const [incidents, setIncidents] = useState([]);
  const [incidentsFilter, setIncidentsFilter] = useState([]);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, incidentFilterFields);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);

  const rowStyle = useCallback((row) => {
    if (row.isBack) {
      return { backgroundColor: "#d2ced6" };
    }
  }, []);

  const checkViewAndEditPermission = useCallback(
    (row) => {
      //let globalPermissions = JSON.parse(localStorage.getItem("globalPermissions"));
      let viewPage = "review";
      let editPage = "review";

      let investigatorId = row?.investigationDetails?.investigator?.id;
      let currentId = getLoggedInUserId();
      if (
        checkStringsAreEqual(
          row.incidentStatus,
          incidentStatuses.investigationProgress
        ) &&
        investigatorId == currentId
      ) {
        viewPage = "investigation";
        editPage = "investigation";
      }

      let viewLink = null;
      if (viewPage) {
        viewLink =
          (siteId ? `/sites/${siteId}` : "") +
          "/health-safety-and-environment/incident-management/" +
          viewPage +
          "/view/" +
          row.id;
      }

      let editLink = null;
      if (editPage) {
        editLink =
          (siteId ? `/sites/${siteId}` : "") +
          "/health-safety-and-environment/incident-management/" +
          editPage +
          "/edit/" +
          row.id;
      }

      return { viewLink, editLink };
    },
    [siteId]
  );

  const onReset = useCallback(() => setFilterForm({}), [setFilterForm]);

  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "incidentId",
        text: "Incident Id.",
        sort: true,
        formatter: (incidentId, row) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
          >
            <Link
              className="icons text-cyanBlue"
              to={`/health-safety-and-environment/incident-management/report/view/${row.id}`}
            >
              {incidentId}
            </Link>
          </OverlayTrigger>
        ),
      },
      {
        dataField: "site.name",
        text: "Location Name",
        sort: true,
      },
      {
        dataField: "site.siteId",
        text: "Location Code",
        sort: true,
        formatter: (ehsSite, row) => {
          return (
            <span
              title={row?.site ? row?.site?.name : ""}
              className="icons text-cyanBlue"
            >
              {row?.site ? row?.site?.siteId : ""}
            </span>
          );
        },
      },
      {
        dataField: "type",
        text: "Incident Type",
        sort: true,
        formatter: (rowContent) => incidentTypes[rowContent],
      },
      {
        dataField: "incidentDate",
        text: "Incident Date",
        sort: true,
        formatter: (rowContent) => DDMMYYYYFormat(rowContent),
      },
      {
        dataField: "generalReasons",
        text: "General-Info Reasons",
        sort: true,
        isExcelOnly: true,
      },
      {
        dataField: "reportedBy",
        text: "Reported By",
        sort: true,
        formatter: (rowContent, row) => {
          return row?.staffType === "employee"
            ? `${fullNameLabel(row?.staffData)}`
            : row?.staffType === "contractor"
            ? `${fullNameLabel(row?.staffData)}`
            : row?.otherStaffName;
        },
      },
      {
        dataField: "staffData.email",
        text: "Email ID",
        sort: true,
        isExcelOnly: true,
      },
      {
        dataField: "staffData.employeeId",
        text: "Emp ID",
        sort: true,
        isExcelOnly: true,
      },
      {
        dataField: "staffData.designation",
        text: "Designation",
        sort: true,
        isExcelOnly: true,
      },
      {
        dataField: "designation",
        text: "Designation",
        sort: true,
        formatter: (rowContent, row) => {
          return row?.staffType === "employee"
            ? `${employeeDesignationLabel(row?.staffData)}`
            : row?.staffType === "contractor"
            ? `${contractorDesignationLabel(row?.staffData)}`
            : "NA";
        },
        isTableOnly: true,
      },
      {
        dataField: "severity",
        text: "Severity",
        sort: true,
        formatter: (rowContent) => {
          return (
            <div className={getIncidentSeverityClass(rowContent)}>
              {severities[rowContent]}
            </div>
          );
        },
      },

      {
        dataField: "area.name",
        text: "Area",
        sort: true,
      },

      {
        dataField: "department.name",
        text: "Department",
        sort: true,
      },
      {
        dataField: "formattedIncidentStatus",
        text: "Status",
        sort: true,
        // formatter: (status, row) =>
        //   INCIDENT_STATUS_VIEW(
        //     row?.incidentStatus,
        //     row?.investigationDetails?.reverted,
        //     row?.isBack,
        //     row
        //   ),
        // formatter: (status) => {
        //   return <div className={getIncidentStatusClass(status)}>{status}</div>;
        // },
      },
      {
        dataField: "shift",
        text: "Shift",
        sort: true,
      },
      {
        dataField: "staffType",
        text: "Staff Type",
        sort: true,
        formatter: (type) => {
          return staffType[type];
        },
      },
      {
        dataField: "createdAt",
        text: "Time Stamp",
        sort: true,
        formatter: (createdAt) => DDMMYYYYHHMMAFormat(createdAt),
      },

      {
        dataField: "create",
        text: "Action",
        formatter: (_rowContent, row) => {
          let linkData = checkViewAndEditPermission(row);
          let viewLink = linkData.viewLink;

          return (
            <div className="actionIconsGroup">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">View</Tooltip>}
              >
                <Link className="icons text-cyanBlue" to={viewLink}>
                  <FiEye />
                </Link>
              </OverlayTrigger>
            </div>
          );
        },
      },
    ],
    [checkViewAndEditPermission]
  );

  /**************** useEffect *************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllIncidentHistory(
          siteId ? `filter[siteId]=${siteId}` : ""
        );
        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        setIncidents(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
    // getAllIncidentHistory(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
    //   if (!response?.data) return;
    //   setIncidents(response.data);
    // });
  }, [siteId]);

  useEffect(() => {
    if (filterForm.hasOwnProperty("ltiHoursUpdate") && filterForm.ltiHoursUpdate === "")
      delete filterForm.ltiHoursUpdate;
    if (
      filterForm.hasOwnProperty("reportEvidencesRequired") &&
      filterForm.reportEvidencesRequired === ""
    )
      delete filterForm.reportEvidencesRequired;

    let data = [];
    if (tab === 1) {
      data = incidents?.reported?.map((d, i) => ({ ...d, sid: i + 1 })) || [];
    }
    if (tab === 2) {
      data = incidents?.safetyOfficer?.map((d, i) => ({ ...d, sid: i + 1 })) || [];
    }
    if (tab === 3) {
      data = incidents?.minesManager?.map((d, i) => ({ ...d, sid: i + 1 })) || [];
    }
    if (tab === 4) {
      data = incidents?.investigator?.map((d, i) => ({ ...d, sid: i + 1 })) || [];
    }

    let result = data
      .filter((row) => {
        let flag = true;
        if (filterForm?.startDate && filterForm?.endDate) {
          flag = isBetween(
            row?.incidentDate,
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (filterForm?.bodyParts) {
          const bodyPartObj = row?.personalDetails?.find((d) =>
            d.bodyParts?.split(",")?.includes(filterForm?.bodyParts)
          );
          if (!bodyPartObj) flag = false;
        }

        if (filterForm?.injuryOutcome) {
          const Obj = row?.personalDetails?.find(
            (d) => d.outcome === filterForm?.injuryOutcome
          );
          if (!Obj) flag = false;
        }
        if (+filterForm?.ltiHoursUpdate === 0 || +filterForm?.ltiHoursUpdate === 1) {
          const isLtiHoursUpdate =
            checkLtiWithType.includes(row?.type) &&
            row?.isPersonalInjury &&
            row?.ltiHoursUpdate === +filterForm?.ltiHoursUpdate;
          if (!isLtiHoursUpdate) flag = false;
        }
        if (
          +filterForm?.reportEvidencesRequired === 0 ||
          +filterForm?.reportEvidencesRequired === 1
        ) {
          const evidenceFlag = !!(
            (+filterForm?.reportEvidencesRequired && row?.reportEvidencesRequired) ||
            (!+filterForm?.reportEvidencesRequired && !row?.reportEvidencesRequired)
          );
          if (!evidenceFlag) flag = false;
        }
        if (
          isArray(filterForm?.generalReasonsFilter) &&
          filterForm?.generalReasonsFilter.length
        ) {
          const areAllPropertiesTrue = filterForm.generalReasonsFilter.every(
            (property) => row?.[property] === true
          );
          if (!areAllPropertiesTrue) {
            flag = false;
          }
        }

        if (filterForm?.incidentStatus && flag) {
          flag = checkStatusByFilter(filterForm?.incidentStatus, row);
        }

        if (flag) flag = validateRowFilter(filterForm, row);

        return flag;
      })
      .map((row) => ({
        ...row,
        severity: CURRENT_SEVERITY(row),
        formattedIncidentStatus: INCIDENT_STATUS_VIEW(
          row?.incidentStatus,
          row?.investigationDetails?.reverted,
          row?.isBack,
          row
        ),
      }));

    setIncidentsFilter(result);
  }, [
    filterForm,
    incidents?.investigator,
    incidents?.minesManager,
    incidents?.reported,
    incidents?.safetyOfficer,
    tab,
  ]);

  useEffect(() => {
    setTab(
      incidents?.reported?.length
        ? 1
        : incidents?.safetyOfficer?.length
        ? 2
        : incidents?.minesManager?.length
        ? 3
        : incidents?.investigator?.length
        ? 4
        : 0
    );
  }, [
    incidents?.investigator?.length,
    incidents?.minesManager?.length,
    incidents?.reported?.length,
    incidents?.safetyOfficer?.length,
  ]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Incident Management",
            path:
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/incident-management",
          },
          {
            name: "My Approval History",
          },
        ]}
        module={ACTIVE_MODULE.incident}
      />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-0">My Approval History</h3>
          <FilterBtn setShowFilter={setShowFilter} />
          <BackBtn url={"/health-safety-and-environment/incident-management"} />
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber">
          <div className="hseMenuLinks card">
            {incidents?.reported?.length > 0 && (
              <a
                href
                onClick={() => setTab(1)}
                className={`pointer${tab === 1 ? " active" : ""}`}
              >
                Reporting Officer
              </a>
            )}

            {incidents?.safetyOfficer?.length > 0 && (
              <a
                href
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
              >
                Safety Officer
              </a>
            )}
            {incidents?.minesManager?.length > 0 && (
              <a
                href
                onClick={() => setTab(3)}
                // style={{pointerEvents: 'none'}}
                className={`pointer${tab === 3 ? " active" : ""}`}
              >
                Mines Manager
              </a>
            )}
            {incidents?.investigator?.length > 0 && (
              <a
                href
                onClick={() => setTab(4)}
                className={`pointer${tab === 4 ? " active" : ""}`}
              >
                Investigator
              </a>
            )}
          </div>
        </div>

        {/* <ToolkitProvider
        striped
        keyField="id"
        data={incidentsFilter}
        columns={sortableColumn}
      >
        {(props) => (
          <>
            {showFilter && (
              <IncidentFilters
                fields={incidentFilterFields}
                setForm={setFilterForm}
                form={filterForm}
                onChange={onChangeFilter}
                onReset={onReset}
              />
            )}
            <div className="d-flex align-items-center justify-content-between pb-3">
              <SearchBar {...props.searchProps} className="mb-0" />
              <div className="btn-toolbar">
                {isUserRO() && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Create Incident</Tooltip>}
                  >
                    <Link
                      className="icons btn-icon font-20 text-cyanBlue"
                      to={
                        (siteId ? `/sites/${siteId}` : "") +
                        "/health-safety-and-environment/incident-management/report/add"
                      }
                    >
                      <FiPlusCircle />
                    </Link>
                  </OverlayTrigger>
                )}
              </div>
            </div>

            <div className="table-responsive material-master-table incidentTable">
              <BootstrapTable
                rowStyle={rowStyle}
                {...props.baseProps}
                bootstrap4
                noDataIndication={"Table is empty"}
              />
            </div>
          </>
        )}
      </ToolkitProvider> */}
        <div className="pt-3">
          {!loading ? (
            <SearchBootstrapTable
              searchKey={"myApprovalHistoryIMDesktopSearch"}
              data={incidentsFilter}
              columns={sortableColumn}
              tableBeforeSearch={() =>
                showFilter ? (
                  <IncidentFilters
                    fields={incidentFilterFields}
                    setForm={setFilterForm}
                    form={filterForm}
                    onChange={onChangeFilter}
                    onReset={onReset}
                  />
                ) : (
                  <></>
                )
              }
              // downloadPermission={"global_globalConfiguration_download"}
              tableKey="myApprovalHistoryIM"
              defaultHideColumn={["reportedBy", "site.siteId"]}
            />
          ) : (
            <NetZeroLoader />
          )}
        </div>
      </div>
    </>
  );
}

export default MyApprovalHistory;
